import Parse from 'parse';
import { singleEntityLoading } from '../mixins/loading-states';
/**
 * @class CartModule
 */
const CartModule = {
  namespaced: true,
  state: {
    ...singleEntityLoading.state,
    cart: new Parse.Object('Cart'),
  },
  mutations: {
    ...singleEntityLoading.mutations,
    setCart(state, cart) {
      state.cart = cart;
    },
  },
  actions: {
    ...singleEntityLoading.actions,
    loadCart({ commit }) {
      if (!Parse.User.current()) {
        return;
      }
      commit('setLoading');
      let query = new Parse.Query('Cart');
      query.equalTo('user', Parse.User.current());

      return query.first().then((result) => {
        if (result) commit('setCart', result);
        commit('setLoaded');
      });
    },
    addToCart({ commit, state }, { type, items }) {
      let cart = state.cart;
      cart.set('user', Parse.User.current());
      if (type === 'products') {
        let products = cart.get('products') || [];

        cart.set('products', products.concat(items));
        commit('setCart', cart);
      }

      if (type === 'systems') {
        let systems = cart.get('systems') || [];
        cart.set('systems', systems.concat(items));
        commit('setCart', cart);
      }

      return cart.save();
    },
    removeFromCart({ dispatch, commit, state }, { type, index }) {
      let cart = state.cart;
      if (type === 'products') {
        let products = cart.get('products') || [];
        products.splice(index, 1);
        cart.set('products', products);
        commit('setCart', cart);
      }

      if (type === 'systems') {
        let systems = cart.get('systems') || [];
        systems.splice(index, 1);
        cart.set('systems', systems);
        commit('setCart', cart);
      }

      return cart.save();
    },
  },
  getters: {
    ...singleEntityLoading.getters,
    cart: (state) => state.cart,
  },
};

export default CartModule;
